export const wasteFieldsByCountry = {
  carrierLicenceId: { UK: true, USA: true, CANADA: true },
  carrierName: { UK: true, USA: true, CANADA: true },
  classificationCode: { UK: true, USA: false, CANADA: false },
  classificationCodePresented: { UK: true, USA: false, CANADA: false },
  clientReference: { UK: true, USA: true, CANADA: true },
  consignmentId: { UK: true, USA: true, CANADA: true },
  containerType: { UK: true, USA: true, CANADA: true },
  facilityOperatorName: { UK: true, USA: true, CANADA: true },
  facilityPermitId: { UK: true, USA: true, CANADA: true },
  facilityPermitPresented: { UK: true, USA: false, CANADA: false },
  facilitySiteAddress: { UK: true, USA: true, CANADA: true },
  knownContainerType: { UK: true, USA: true, CANADA: true },
  measurementVolume: { UK: true, USA: true, CANADA: true },
  measurementWeight: { UK: true, USA: true, CANADA: true },
  notes: { UK: true, USA: true, CANADA: true },
  originSiteAddressKnown: { UK: true, USA: true, CANADA: true },
  quantity: { UK: true, USA: true, CANADA: true },
  receiverReferenceNumber: { UK: true, USA: true, CANADA: true },
  removalDate: { UK: true, USA: true, CANADA: true },
  removalExitDate: { UK: true, USA: true, CANADA: true },
  subcontractorName: { UK: true, USA: true, CANADA: true },
  supplierReferenceNumber: { UK: true, USA: true, CANADA: true },
  vehicleRegistration: { UK: true, USA: true, CANADA: true },
  volume: { UK: true, USA: true, CANADA: true },
  wasteCode: { UK: true, USA: false, CANADA: false },
  wasteDescription: { UK: true, USA: true, CANADA: true },
  wasteManagementRoutesSource: { UK: true, USA: false, CANADA: false },
  weight: { UK: true, USA: true, CANADA: true }
}
